// extracted by css-extract-rspack-plugin
export default {"grid":"grid_dZBrg","table":"table_zcVLr","pagination":"pagination_DzSki"};